import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=bb82148a&scoped=true"
import script from "./NewCampaign.vue?vue&type=script&lang=js"
export * from "./NewCampaign.vue?vue&type=script&lang=js"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&id=bb82148a&prod&scoped=true&lang=css"
import style1 from "./NewCampaign.vue?vue&type=style&index=1&id=bb82148a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb82148a",
  null
  
)

export default component.exports